import React from 'react';
import Icon from './Icon';
import {IconProps} from './IconProps';


export default function IconPaid({className, height, title}: IconProps) {
  return (
    <Icon className={className} height={height} title={title}>
      M19 4.00009C19.2981 4.28761 19.3068 4.76241 19.0192 5.06058L7.78846 16.7073C7.59183 16.9112 7.26524 16.9112 7.06861 16.7073L0.980685 10.3939C0.693164 10.0957 0.701797 9.62095 0.999966 9.33343C1.29814 9.04591 1.77293 9.05454 2.06045 9.35271L7.06862 14.5464C7.26524 14.7503 7.59183 14.7503 7.78846 14.5464L17.9395 4.01938C18.227 3.72121 18.7018 3.71257 19 4.00009Z
    </Icon>
  );
}
